<template>
  <div class="completion-view">
    <ContentLayout>
      <div class="completion-view__content">
        <h1 class="completion-view__heading">
          <Heading :value="completionSettings.title" />
        </h1>
        <div class="completion-view__info-box">
          <InfoBox :description="completionSettings.message" />
        </div>
        <div class="completion-view__email-box">
          <EmailBox
            :title="completionSettings.contact.label"
            :email="completionSettings.contact.email"
          />
        </div>
        <div class="completion-view__cta">
          <SimpleButton
            :to="testRoute"
            :title="completionSettings.button"
            light
          />
        </div>
        <div class="completion-view__fb">
          <IconButton
            :label="completionSettings.facebook.label"
            :link="completionSettings.facebook.link"
          />
        </div>
      </div>
    </ContentLayout>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import store from "@/store";
import { loadProgramData } from "@/utils";
import { Routes } from "@/constants";

import InfoBox from "@/components/InfoBox";
import EmailBox from "@/components/EmailBox";
import SimpleButton from "@/components/SimpleButton";
import IconButton from "@/components/IconButton";
import Heading from "@/components/Heading";
import ContentLayout from "@/layouts/ContentLayout";

export default {
  name: "CompletionView",
  data() {
    return {
      testRoute: Routes.quiz.path
    };
  },
  components: {
    InfoBox,
    EmailBox,
    SimpleButton,
    IconButton,
    Heading,
    ContentLayout
  },
  computed: {
    ...mapState({
      completionSettings: state => state.completionSettings
    })
  },
  methods: {
    ...mapActions({
      triggerScrollTop: "triggerScrollTop"
    })
  },
  beforeCreate() {
    if (!loadProgramData(store.state.resultProgram)) {
      this.$router.push(Routes.loading.path);
    }
  },
  mounted() {
    this.triggerScrollTop();
  }
};
</script>

<style lang="scss" scoped>
.completion-view {
  height: 100%;
  width: 100%;

  &__content {
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    min-height: 100%;
    padding: 0 spacer("l");

    @include if-tablet {
      max-width: 800px;
    }
  }

  &__heading {
    animation: enterChain 1.2s forwards ease;
    margin-bottom: spacer("l");

    @include if-tablet {
      margin-bottom: spacer("l") * 2;
    }
  }

  &__info-box {
    animation: enterChain 1.2s 0.2s forwards ease;
    opacity: 0;
    margin-bottom: spacer("l");
  }

  &__email-box {
    animation: enterChain 1.2s 0.4s forwards ease;
    opacity: 0;
    margin-bottom: spacer("l");
  }

  &__cta {
    animation: enterChain 1.2s 0.6s forwards ease;
    opacity: 0;
    margin-bottom: spacer("l");
  }

  &__fb {
    animation: enterChain 1.2s 0.8s forwards ease;
    opacity: 0;
    margin-bottom: spacer("l");
  }

  @keyframes enterChain {
    0% {
      transform: translateY(30px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
</style>
